// extracted by mini-css-extract-plugin
module.exports = {"geniusHighlightTooltipButton":"FlightCardGeniusHighlightTooltipWrapper-module__geniusHighlightTooltipButton___uHFzU"};